export default {
    permissions: state => {
        return state.permissions;
    },
    formattedPermissions: state => {
        return state.formattedPermissions;
    },
    permissionGroups: state => {
        return state.permissionGroups;
    },
    permissionGroupTitle: state => {
        return state.permissionGroupTitle;
    },
    permissionToCreate: state => {
        return state.permissionToCreate;
    },
    selectedUserPermissions: state => {
        return state.selectedUserPermissions;
    },
    selectedUserPermissionGroups: state => {
        return state.selectedUserPermissionGroups;
    },
    groupToEdit: state => {
        return state.groupToEdit;
    },
    permissionToEdit: state => {
        return state.permissionToEdit;
    },
    permissionUnits: state => {
        return state.permissionUnits;
    },
    userPermissionUnits: state => {
        return state.userPermissionUnits;
    },
    permissionRooms: state => {
        return state.permissionRooms;
    },
    userPermissionRooms: state => {
        return state.userPermissionRooms;
    },
    userPermissionRepeaterRooms: state => {
        return state.userPermissionRepeaterRooms;
    },

}
